import { Alert, AlertColor, Box, Button, CircularProgress, Collapse, Icon, Skeleton, TextField } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Crypter } from '../Functions/Security/Crypter';
import Hash from '../Functions/Security/Hash';
import Agence from '../Models/Agence';
import ApiResponse from '../Models/ApiResponse';
import DoubleTexfield from './DoubleTexfield';
import Message from './Message';
import Data from "../Data/Data.json"
import { Link, redirect, useNavigate } from 'react-router-dom';
import { useSession } from '../Services/Auth/sessionAuth';
import SetCookie from './Hooks/Cookies/SetCookie';
import UpdatePassword from './Forms/UpdatePassword';
import { Console } from 'console';
import ParamsPicklist from '../Types/ParamsPicklist';
import Datas from '../Data/Data.json'
import SweetAlert from "sweetalert2";
import formatDate from '../Functions/Traitement/fomatDate';
import ReformatDate from '../Functions/Traitement/ReformatDate';
import { Book, LibraryBooks, LibraryBooksTwoTone, OpenInBrowser } from '@mui/icons-material';
import Fermer from "../Res/journeFerme.png";
import Ouvert from "../Res/journeOuverte.png";
import { AgenceSelect, useAgence } from '../AgenceContext';
import MfaChallengeDialog from './Mfa/MfaChallengeDialog';
import { mfaApi, MfaResolutionResult, parseEncryptedResponse, logMfaRequest, logMfaSuccess, logMfaError } from './Mfa/mfaApi';


const LoginForm = (props: { mode?: string }) => {
    const [agences, setAgences] = useState<Agence[]>([]);
    const [agceSelect, setAgceSelect] = useState<AgenceSelect[]>([]);
    const [apiResponse, setApiResponse] = useState<ApiResponse>();
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const methods = useForm();
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [typeMessage, setTypeMessage] = useState<AlertColor>("error");
    const [load, setLoad] = useState(false);
    const [loadBranch, setLoadBranch] = useState(true);
    const { t, i18n } = useTranslation();
    const [firstConexion, setFirstConexion] = useState(false);
    const [name, setName] = useState("");
    const [expiredPassword, setExpiredPassword] = useState(false);
    const [expiredName, setExpiredName] = useState("");
    const [DateJour, setDateJour] = useState("");
    const [CaisseUser, setCaisseUser] = useState("");
    const [active, setActive] = useState(true);
    const [JourneeOuvert, setJourneeOuvert] = useState(false);
    const [connect, setConnect] = useState(false);
    const [mfaDialogOpen, setMfaDialogOpen] = useState(false);
    const [mfaPayload, setMfaPayload] = useState<any>(null);
    const [mfaUser, setMfaUser] = useState<any>(null);
    const [loginLockout, setLoginLockout] = useState<number>(0);

    const formatCountdown = (seconds: number) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    };

    useEffect(() => {
        if (loginLockout <= 0) return;
        const interval = setInterval(() => {
            setLoginLockout((prev) => (prev <= 1 ? 0 : prev - 1));
        }, 1000);
        return () => clearInterval(interval);
    }, [loginLockout]);

    const extractLoginLockoutSeconds = (res: any): number => {
        const status = Number(res?.StatutCode ?? res?.StatusCode ?? res?.statusCode ?? 0);
        const secs = Number(res?.Result?.LockoutSeconds ?? res?.Result?.lockoutSeconds ?? 0);
        return status === 429 || secs > 0 ? Math.max(secs, 1) : 0;
    };

    const [pageIsLoad, setPageIsLoad] = useState(true);
    const navigat = useNavigate()
    const { refreshSession, signIn } = useSession()
    const { setAgence } = useAgence();

    function logConnectedUser(source: string, value: any) {
        const result = value?.Result ?? value?.result ?? value ?? {};
        const role = String(result.role ?? result.Role ?? result.codgroup ?? result.CodGroup ?? result.group ?? result.Group ?? '').trim();
    }

    const checkPasswordExpiry = (codUti: string, onProceed: () => void) => {
        axios.get(mfaApi.passwordExpiryStatus(codUti), { withCredentials: true })
            .then((expiryRes) => {
                const payload = parseEncryptedResponse(expiryRes);
                const state = payload?.Result?.State ?? payload?.Result?.state ?? 'OK';
                const daysRemaining = payload?.Result?.DaysRemaining ?? payload?.Result?.daysRemaining;
                if (state === 'Locked' || state === 'locked') {
                    setLoad(false);
                    SweetAlert.fire({
                        icon: 'error',
                        title: 'Compte bloqué',
                        text: 'Votre compte est bloqué en raison de l\'expiration de votre mot de passe. Veuillez contacter l\'administrateur ou le support.',
                        confirmButtonColor: '#0d4a70',
                    });
                    return;
                }
                if (state === 'Expired' || state === 'expired') {
                    setLoad(false);
                    setExpiredName(codUti);
                    setExpiredPassword(true);
                    return;
                }
                if (state === 'Warning' || state === 'warning') {
                    setLoad(false);
                    SweetAlert.fire({
                        icon: 'warning',
                        title: 'Expiration prochaine',
                        text: `Votre mot de passe expire dans ${daysRemaining} jour(s).`,
                        showCancelButton: true,
                        confirmButtonText: 'Changer maintenant',
                        cancelButtonText: 'Continuer',
                        confirmButtonColor: '#0d4a70',
                    }).then((choice) => {
                        if (choice.isConfirmed) {
                            setExpiredName(codUti);
                            setExpiredPassword(true);
                        } else {
                            onProceed();
                        }
                    });
                    return;
                }
                onProceed();
            })
            .catch((err) => {
                onProceed();
            });
    };

    const handleMfaSuccess = (result: any) => {
        setLoad(false);
        setMfaDialogOpen(false);
        setMfaUser(null);
        setMfaPayload(null);
        const codUti = result?.coduti ?? mfaUser?.coduti ?? '';
        checkPasswordExpiry(codUti, () => {
            logConnectedUser('LOGIN_AVEC_MFA', result);
            navigat('/');
        });
    };

    // Intervale de visibilité du message
    if (showMessage) {
        setTimeout(() => {
            setShowMessage(false)
        }, 10000)
    }

    if (pageIsLoad) {
        //alert(Data.ApiUrl.authentification)
        loadAgence()
        setPageIsLoad(false)
    }
     function  loadAgenceSelect(codage: string) {
        // alert(codage)
        //setActive(true)
       // setDateJour("")
       // setJourneeOuvert(false)
       // setConnect(false)
       setAgceSelect([])
        if (codage != "") {
            let searchAgence: ParamsPicklist = { CodeAgence: '', Table: "agence", Colonne1: "CODAGE", Colonne2: "", Init: codage.trim(), Colagence: '', Choix: 35 }
         //let searchClientComptes: ParamsPicklist = { CodeAgence: codage, Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "datjour", Init: '', Colagence: 'codage', Choix: 22 }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Datas.ApiUrl.AnySearchWithoutAuth,
                headers: {
                    'Content-Type': 'application/json',
                    'CypherSearch': Crypter.encrypt(JSON.stringify(searchAgence))
                }
            };
             axios(config)
                .then((response) => {

                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        //alert(JSON.stringify(res))
                        if (res.StatutCode == 200) {
                           
                            let datas = res.Result.Table[0];
                          
                            if (datas.length !== 0) {
                                setAgceSelect(datas)
                                setAgence(datas)
                                const Branch = agceSelect.find(
                                (agence) => agence.CODAGE.trim() === res.Result.codage.trim()
                                 );
                          
                            //   if (Branch) {
                            //  setAgence(Branch); // 🔥 l’agence est maintenant dispo partout
                            //       }
                               // SweetAlert.fire({ title: "Your branch dont allow to connect", icon: "warning" })
                            }
                           
                        } 
                    }
                }).catch((error) => {
                    SweetAlert.fire({ title: error, icon: "error" })
                })

        }
    }
    function loadAgence() {
      //  alert('helle')
        setLoadBranch(true)
        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.allBranchs,
            headers: {
                'Authorization': Data.SecretKey.ApiToken
            },
        };

        axios(config)
            .then(function (response) {
                if (response.data) {
                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                    if (res.StatutCode == 200) {
                        setAgences(res.Result)
                       // alert("uuuu")
                     //  console.log(res.Result)
                        //setAgceSelect(res.Result)
                       // console.log(res.Result)
                        setMessage((t("texte.connexion_possible")) + "")
                        setTypeMessage("success")
                    }
                    else {
                        setMessage(res.Message + "")
                        setTypeMessage("error")
                    }
                    setShowMessage(true)
                }
                //console.log(JSON.stringify(response.data));
            })
            .catch(function (error) {
                if (error.response) {
                    setMessage(error.response.data["message"])
                } else {
                    setMessage(error.message)
                }
                setTypeMessage("error")
                setShowMessage(true)
                setAgences([]);
            }).finally(() => {
                //console.log(agences)
                setLoadBranch(false)
            });
    }

    function onSubmit(data: any) {
        //alert(DateJour)
        if(DateJour != ""){
            //if(connect){
        //alert(data)
        setName("")
        setFirstConexion(false)
        setLoad(true)
        data["motpas"] = Hash(data["motpas"]);
        data["codage"] = (data["codage"].split('-')[0]).trim()
        //console.log(Crypter.encrypt(JSON.stringify(data)))
        var config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: mfaApi.login,
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true,
            data: Crypter.encrypt(JSON.stringify(data))
        };

        loadCaisseUser(data["codage"],data["coduti"])
        axios(config)
            .then(async function (response) {

                        // BEGIN CSRF
            // // Le cookie AuthToken (HttpOnly) vient d'être posé par le serveur.
            // // On récupère maintenant le cookie CSRF (XSRF-TOKEN, lisible par JS)
            // // nécessaire pour toutes les futures requêtes POST/PUT/DELETE.
            // try {
            //     await axios.get('https://localhost:7145/Authentification/csrf-token', {
            //         withCredentials: true,
            //     });
            //     console.info('[AUTH DEBUG] CSRF token cookie initialisé',
            //         { cookieVisible: document.cookie.includes('XSRF-TOKEN=') });
            // } catch (csrfErr) {
            //     console.error('[AUTH DEBUG] Échec récupération du token CSRF', csrfErr);
            // }
            // // END CSRF
                if (response.data) {
                    const res = parseEncryptedResponse(response);

                    const requiresMfa = Boolean(res?.RequiresMfa ?? res?.requiresMfa);

                if (requiresMfa) {
                    // IMPORTANT : ne PAS rappeler /MfaPolicyResolver/Resolve ici.
                    // res.Result n'existe pas sur la réponse de /Authentification/connexion
                    // (ConnexionMfa renvoie Method/PolicySource à la racine de l'objet, pas
                    // sous Result) — donc `result.codgroup` valait TOUJOURS undefined, et le
                    // second appel resolvePolicy(coduti, codage, undefined) écrasait la bonne
                    // résolution déjà faite par le serveur (avec le codgroup correctement
                    // scopé à l'agence de connexion via profilDistantUtilis dans sp_connexion)
                    // par une résolution ratée retombant sur Method=None. Conséquence : un
                    // utilisateur avec une politique de rôle/agence active se retrouvait à
                    // l'écran de libre choix de méthode au lieu de la méthode imposée.
                    //
                    // Le serveur a déjà tout calculé : on réutilise res.Method/res.PolicySource
                    // tels quels, sans second aller-retour réseau.
                    const resolvedMethod = Number(res?.Method ?? 0);
                    const policyData: MfaResolutionResult = {
                        method: resolvedMethod,
                        source: res?.PolicySource ?? '',
                        isRequired: resolvedMethod !== 0,
                        reason: res?.Reason ?? (res?.PolicySource ? `${res.PolicySource} impose cette méthode` : ''),
                    };
                    sessionStorage.setItem('resolvedMfaPolicy', JSON.stringify(policyData));

                    const result = res.Result ?? {};

                    const userState = {
                        coduti: result.coduti ?? data["coduti"],
                        nomuti: result.nomuti ?? result.nom ?? "",
                        codage: result.codage ?? data["codage"],
                        agence: result.agence ?? "",
                        codgroup: result.codgroup ?? "",
                        group: result.group ?? "",
                        datjour: DateJour,
                        CaisseUser: CaisseUser,
                    };

                    logConnectedUser('MFA_PENDING', userState);

                    const mfaConfigured = Boolean(res?.MfaConfigured ?? res?.mfaConfigured);

                    // Indicateurs MFA persistés pour la garde RequireAuth et les pages
                    // /mfa-activation & /mfa-verify : ils survivent à un changement
                    // d'URL manuel ou à un rechargement, afin que l'utilisateur soit
                    // TOUJOURS renvoyé vers l'activation/vérification tant que la
                    // session serveur porte MfaVerified=false.
                    sessionStorage.setItem('mfaRequired', 'true');
                    sessionStorage.setItem('requiresSetup', String(!mfaConfigured));
                    sessionStorage.setItem('assignedMfaMethod', String(resolvedMethod));
                    if (userState.coduti) sessionStorage.setItem('codUti', String(userState.coduti));

                    if (!mfaConfigured) {
                        checkPasswordExpiry(userState.coduti, async () => {
                            // Le backend a désormais posé le cookie AuthToken (mfa_verified=false)
                            // AVANT de renvoyer cette réponse : on doit donc vérifier la VRAIE
                            // session serveur via refreshSession(), pas bricoler un état client
                            // avec signIn({authState:...}) qui ne prouve rien à RequireAuth.
                            const authenticated = await refreshSession();
                            if (!authenticated) {
                                setTypeMessage("error");
                                setMessage("La session serveur n'a pas pu être initialisée.");
                                setShowMessage(true);
                                return;
                            }
                            setMessage("MFA attribué mais non configuré. Veuillez configurer votre MFA.");
                            setTypeMessage("warning");
                            setShowMessage(true);
                            navigat("/mfa-activation");
                        });
                        return;
                    }

                    // MFA déjà configuré → vérifier l'expiration avant d'afficher le dialogue.
                    // Si le mot de passe est expiré, on force le changement avant toute vérification MFA.
                    checkPasswordExpiry(userState.coduti, () => {
                        setMfaPayload(res);
                        setMfaUser(userState);
                        setMfaDialogOpen(true);
                        setMessage("Vérification MFA requise pour finaliser la connexion.");
                        setTypeMessage("warning");
                        setShowMessage(true);
                    });
                    return;
                }

                    const businessStatus = Number(res?.StatutCode ?? res?.StatusCode ?? 200);
                    const loginSucceeded = response.status >= 200
                        && response.status < 300
                        && businessStatus >= 200
                        && businessStatus < 300
                        && res?.Authenticated !== false;

                    if (loginSucceeded) {
                        // Connexion sans MFA : on purge d'éventuels indicateurs MFA
                        // résiduels d'une tentative précédente pour ne pas fausser
                        // la garde RequireAuth.
                        sessionStorage.removeItem('mfaRequired');
                        sessionStorage.removeItem('requiresSetup');
                        sessionStorage.removeItem('assignedMfaMethod');
                        signIn({
                            authState: {
                                coduti: data["coduti"],
                                codage: data["codage"],
                                datjour: DateJour,
                                CaisseUser,
                            },
                        });
                        setMessage(res?.Message ?? "Connexion réussie.")
                        if (res?.Result?.codage) {
                            loadAgenceSelect(res.Result.codage)
                        }

                        const proceedAfterExpiry = () => {
                            refreshSession().then((authenticated) => {
                                if (authenticated) {
                                    logConnectedUser('LOGIN_SANS_MFA', res);
                                    navigat("/")
                                } else {
                                    setTypeMessage("error")
                                    setMessage("Une erreur inatendue est survenue! veillez contacter votre administrateur")
                                }
                            })
                        }

                        const codUti = res?.Result?.coduti ?? data["coduti"]
                        checkPasswordExpiry(codUti, proceedAfterExpiry)
                    }
                    else {
                        if (res?.Message?.split("|||")[1] == Data.LocalVariable.firstConnexion) {

                            setMessage(res.Message.split("|||")[1])
                            setName(data["coduti"] + "-" + res.Message.split("|||")[0])
                            setValue("motpas", "")
                            setFirstConexion(true)
                            setTypeMessage("warning")
                        }
                        else if (extractLoginLockoutSeconds(res) > 0) {
                            setLoginLockout(extractLoginLockoutSeconds(res))
                            setMessage(res?.Message ?? "Trop de tentatives de connexion. Veuillez patienter.")
                            setTypeMessage("warning")
                        }
                        else {
                            setMessage(res?.Message ?? "Identifiants invalides.")
                            setTypeMessage("error")
                        }

                    }
                    setShowMessage(true)
                }
            })
            .catch(function (error) {
                const parsedError = error.response ? parseEncryptedResponse(error.response) : null;
                const lockoutSecs = extractLoginLockoutSeconds(parsedError);
                if (lockoutSecs > 0) {
                    setLoginLockout(lockoutSecs);
                    setMessage(parsedError?.Message ?? "Trop de tentatives de connexion. Veuillez patienter.");
                    setTypeMessage("warning");
                }
                else if (error.response) {
                    setMessage(parsedError?.Message ?? error.response.data["message"] + "")
                    setTypeMessage("error")
                }
                else {
                    setMessage(error.message)
                    setTypeMessage("error")
                }
                setShowMessage(true)

            }).finally(() => {
                setLoad(false)
            });
        //}
        //else{
        //    SweetAlert.fire({ title: "Your branch dont allow to connect", icon: "warning" })
        //}
        }else{
            SweetAlert.fire({ title: "Date comptable non chargée", icon: "warning" })
        }

    }
    // if(firstConexion){
    //     setTimeout(()=>{
    //         setFirstConexion(false)
    //     }, 5000)
    // }

    async function loadDateJour(codage: string) {
       // alert(codage)
        setActive(true)
        setDateJour("")
        setJourneeOuvert(false)
        setConnect(false)
        if (codage != "") {
            let searchClientComptes: ParamsPicklist = { CodeAgence: '', Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "datjour", Init: codage.trim(), Colagence: 'codage', Choix: 31 }
         //let searchClientComptes: ParamsPicklist = { CodeAgence: codage, Table: "DATGEN", Colonne1: "CODAGE", Colonne2: "datjour", Init: '', Colagence: 'codage', Choix: 22 }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Datas.ApiUrl.AnySearchWithoutAuth,
                headers: {
                    'Content-Type': 'application/json',
                    'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
                }
            };
            await axios(config)
                .then((response) => {

                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        //alert(JSON.stringify(res))
                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table[0];
                            if (datas.length === 0) {
                                SweetAlert.fire({ title: "Your branch dont allow to connect", icon: "warning" })
                            }
                            else {
                                setConnect(true)
                                setDateJour(ReformatDate(datas["DATJOUR"]));
                                setActive(false)
                                setJourneeOuvert(true)
                            }
                        } else {
                            setConnect(false)
                            SweetAlert.fire({ title: "Your branch dont allow to connect", icon: "warning" })
                        }
                    }
                }).catch((error) => {
                    SweetAlert.fire({ title: error, icon: "error" })
                })

        }
    }

    async function loadCaisseUser(CodAge: string,CodUser: string) {
       
       // setActive(true)
        setCaisseUser("")
       // setJourneeOuvert(false)
      //  setConnect(false)
        if (CodUser != "") {
            
            let searchClientComptes: ParamsPicklist = { CodeAgence:CodAge , Table: "CAI", Colonne1: "LECEON", Colonne2: "NODECE", Colagence: 'AEGECE',colfiltre:"NMURCR",valfiltre:CodUser, Choix: 22 }

            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Datas.ApiUrl.AnySearchWithoutAuth,
                headers: {
                    'Content-Type': 'application/json',
                    'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
                }
            };
            await axios(config)
                .then((response) => {

                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                         
                        //alert(JSON.stringify(res.StatutCode))
                        if (res.StatutCode == 200) {
                            let datas = res.Result.Table[0];
                            if (datas.length === 0) {
                                //  alert(datas["NODECE"])
                                //SweetAlert.fire({ title: "Your branch dont allow to connect", icon: "warning" })
                                setCaisseUser("");
                            }
                            else {
                                //setConnect(true)
                                setCaisseUser((datas["NODECE"]));
                               // alert(datas["NODECE"])
                               // setActive(false)
                               // setJourneeOuvert(true)
                            }
                        } else {
                            setCaisseUser("");
                           // setConnect(false)
                           // SweetAlert.fire({ title: "Your branch dont allow to connect", icon: "warning" })
                        }
                    }
                }).catch((error) => {
                    SweetAlert.fire({ title: error, icon: "error" })
                })

        }
    }


    return (
        <>
            <FormProvider {...methods}>
                <form className='form' onSubmit={handleSubmit(onSubmit)}>
                    <p className='form-title'>{t("titre.se-connecter")}</p><br />

                    {loadBranch ? <><Skeleton variant='rounded' height={45} /><br /></> : ""}
                    <Collapse sx={{ width: '100%' }} in={showMessage}>
                        <Message Message={message} type={typeMessage} />
                    </Collapse>
                    {loginLockout > 0 && (
                        <Alert severity="warning" sx={{ width: '100%', mb: 2, textAlign: 'center' }}>
                            Trop de tentatives de connexion. Veuillez patienter : <b>{formatCountdown(loginLockout)}</b>
                        </Alert>
                    )}

                    <DoubleTexfield
                        HandleFunction={loadDateJour}
                        register={register("codage")}
                        data={agences}
                        placeholderCode={t("input.agence").toString()}
                        placeholderText={t("input.code-agence").toString()}
                        mode={props.mode}
                    /><br />

                    <Box display={'flex'} borderRight={1} borderColor={"inherit"} borderRadius={"5px"}>

                        <TextField
                            className={(props.mode == 'light') ? "" : 'd-textfield' + " input-code"}
                            color='success'
                            required
                            id="outlined-basic-1"
                            label={t('input.date-connexion')}
                            disabled type={"text"}
                            variant="filled"
                            fullWidth
                            onChange={() => { }}
                            value={DateJour}
                        />
                        <Icon fontSize='large'><img draggable={false} width={JourneeOuvert ? 30 : 40} src={JourneeOuvert ? Ouvert : Fermer} alt="" /></Icon>
                    </Box>

                    <br />

                    <TextField
                        {...register("coduti", { required: true, maxLength: 10 })}
                        className={(props.mode == 'light') ? "" : 'd-textfield' + " input-code"}
                        color='success'
                        id="outlined-basic"
                        label={t('input.id-utilisateur')}
                        type={"text"} variant="filled"
                        fullWidth
                    /><br /><br />

                    <TextField
                        {...register("motpas", { required: true })}
                        className={(props.mode == 'light') ? "" : 'd-textfield' + " input-code"}
                        color='success'
                        id="outlined-basic"
                        label={t('input.pwd')}
                        type={"password"}
                        variant="filled"
                        fullWidth
                    /><br /><br />

                    <Button
                        size='large'
                        variant='contained'
                        // color='success'
                        style={{backgroundColor: "#116599"}}
                        disabled={load || loginLockout > 0}
                        endIcon={
                            load ? <CircularProgress size={"20px"} color='inherit' /> : ""
                        }
                        className='btn-submit'
                        type='submit'
                    >
                        {t("bouton.connexion").toString()}
                    </Button>
                </form>
            </FormProvider>

            {firstConexion ? <UpdatePassword name={name} /> : ''}

            {expiredPassword ? <UpdatePassword f={() => setExpiredPassword(false)} name={expiredName} /> : ''}

            {mfaUser && (
                <MfaChallengeDialog
                    open={mfaDialogOpen}
                    onClose={() => {
                        setMfaDialogOpen(false);
                        setMfaUser(null);
                        setMfaPayload(null);
                    }}
                    onMfaSuccess={handleMfaSuccess}
                    user={mfaUser}
                    credentials={{ codage: mfaUser.codage ?? '', coduti: mfaUser.coduti ?? '', motpas: '' }}
                    initialPayload={mfaPayload}
                />
            )}
        </>
    );
};

export default LoginForm;